/**
 * Clientes da Operax: fonte única da faixa da home e da página `/clientes`.
 *
 * Só entra empresa que autorizou aparecer. O logo vai em `public/clientes/<slug>.jpeg`;
 * enquanto não existe arquivo, o card mostra a inicial da empresa. Quando chegar o
 * logo, basta preencher `logo` aqui, sem mexer em nenhum componente.
 *
 * Resultado e métrica só com número medido no painel do cliente e autorizado por ele.
 */
export interface Client {
  slug: string;
  name: string;
  /** Ramo de atuação, em poucas palavras. */
  segment?: string;
  /** Caminho em `public/`. Ausente = ainda sem logo. */
  logo?: string;
  /** Uma linha com o que a empresa faz na Operax. Só o que o cliente já nos contou. */
  usage?: string;
  /** Página com o caso completo, quando existe. */
  href?: string;
}

export const clients: Client[] = [
  {
    slug: 'protvaco',
    name: 'Protvaço',
    segment: 'Proteção veicular',
    logo: '/clientes/protvaco.jpeg',
    usage: '94% das cobranças entregues pelo WhatsApp oficial',
    href: '/casos/protvaco',
  },
  {
    slug: 'consultorio-dr-lucas',
    name: 'Dr. Lucas de Souza Ferreira',
    segment: 'Ginecologia e obstetrícia',
    logo: '/clientes/drlucas.jpeg',
    usage: 'Paciente escolhe o horário e agenda pelo WhatsApp',
    href: '/casos/consultorio-dr-lucas',
  },
  {
    slug: 'metodo-stop-gastos',
    name: 'Fernanda Educação Financeira',
    segment: 'Educação financeira',
    logo: '/clientes/fernanda.jpeg',
    usage: 'Jornada do novo aluno no automático, até a liberação do app',
    href: '/casos/metodo-stop-gastos',
  },
  {
    slug: 'prime-ambientes',
    name: 'Prime Ambientes | Italínea',
    segment: 'Ambientes planejados',
    logo: '/clientes/prime-ambientes.jpeg',
  },
  {
    slug: 'micheli-valadares-podologia',
    name: 'Micheli Valadares Podologia',
    segment: 'Podologia',
    logo: '/clientes/micheli.jpeg',
  },
  {
    slug: 'agrodias',
    name: 'Agrodias',
    segment: 'Casa do fazendeiro',
    logo: '/clientes/agrodias.jpeg',
    usage: 'PDV e estoque nas vendas da loja',
  },
  {
    slug: 'agro-store',
    name: 'Agro Store',
    segment: 'Moda country',
    logo: '/clientes/agrostore.jpeg',
  },
  {
    slug: 'cartao-mais-vida',
    name: 'Cartão Mais Vida',
    segment: 'Cartão de benefícios em saúde',
    logo: '/clientes/maisvida.jpeg',
  },
  {
    slug: 'supermercado-somar',
    name: 'Supermercado Somar',
    segment: 'Supermercado',
    logo: '/clientes/somar.jpeg',
    usage: 'Atendimento ao cliente pelo WhatsApp oficial',
    href: '/casos/supermercado-somar',
  },
  {
    slug: 'artes-papelaria',
    name: 'Artes Papelaria',
    segment: 'Papelaria',
    logo: '/clientes/artes-papelaria.jpeg',
    // Usa o app Estoque. Atendimento automatizado de pedidos escolares em implantação: ainda não é resultado, não publicar como tal.
    usage: 'Estoque da loja',
  },
  {
    slug: 'world-car-new',
    name: 'World Car New',
    segment: 'Centro automotivo',
    logo: '/clientes/worldcarnew.jpeg',
  },
];

export function clientInitials(name: string): string {
  const parts = name.replace(/^(Dr\.|Dra\.)\s+/i, '').split(/\s+/).filter(Boolean);
  return parts
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join('');
}

export function findClient(slug: string): Client | undefined {
  return clients.find((c) => c.slug === slug);
}
